export const getStoreData = () => {
    let data = {}
    
    Array.prototype.forEach.call(document.querySelectorAll('input[type=hidden]'), (el) => {
        if (el.value) {
            data[el.name] = el.value 
        }
        if (el.dataset.data) {
            try {
                data[el.name] = el.dataset.data ? JSON.parse(el.dataset.data) : undefined
            } catch (e) {
                data[el.name] = undefined
            }
        }
    })

    return data
}